import styled from 'styled-components';
import LoadingAnimation from '../../../../../components/loadingAnimation';

interface ILoadingUIProps {
  message?: string;
}

const LoadingUI = ({ message = 'Loading...' }: ILoadingUIProps) => {
  return (
    <LoadingContainer>
      <LoadingAnimation />
      <span className="loading-text">{message}</span>
    </LoadingContainer>
  );
};

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .loading-text {
    font-size: 1.2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.text};
  }
`;

export default LoadingUI;
